module.exports = __webpack_public_path__ + "img/uv.fbdb027a.jpg";